module.exports = __webpack_public_path__ + "img/Profil-AUE.2963a154.png";